import { createRoute } from '@tanstack/react-router';

import { InspirationDashboard } from '$/pages/DashboardPages/pages/Inspiration';
import { useInspirationStore } from '$/pages/DashboardPages/pages/Inspiration/stores/useInspirationStore';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { STANDARD_STALE_TIME } from '$/services/constants';

export const InspirationsRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/inspirations',
  component: InspirationDashboard,
  staleTime: STANDARD_STALE_TIME,
  beforeLoad: () => {
    useInspirationStore.setState({ activeCategory: null });
  },
});
